import { disputeAlertViewSchema_ } from "@redotech/redo-dispute-common/dispute-alert-view-definition";
import {
  disputeAlertSortableColumns,
  disputeAlertStatus,
  disputeAlertType,
} from "@redotech/redo-dispute-db-schema/dispute-alert-definition";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

// The alert view plus the merchant identity, resolved per-batch in the handler.
const reclaimAlertRowSchema_ = disputeAlertViewSchema_.extend({
  teamName: z.string().nullish(),
  teamId: z.string().nullish(),
});

export const reclaimAlertRowSchema: z.ZodType<ReclaimAlertRow> =
  reclaimAlertRowSchema_;

export interface ReclaimAlertRow
  extends z.infer<typeof reclaimAlertRowSchema_> {}

// Cross-account list of synced dispute alerts for the admin Alerts tab. Mirrors
// getReclaimDisputes.
export const getReclaimAlerts = unaryRpc({
  name: "getReclaimAlerts" as const,
  input: z.object({
    offset: z.number().int().min(0).optional(),
    limit: z.number().int().min(1).max(1000).optional(),
    statuses: z.array(z.enum(disputeAlertStatus)).optional(),
    types: z.array(z.enum(disputeAlertType)).optional(),
    sort: z
      .object({
        sortBy: z.enum(disputeAlertSortableColumns),
        sortDirection: SortDirectionSchema,
      })
      .optional(),
  }),
  output: z.object({ alerts: z.array(reclaimAlertRowSchema) }),
});
